import { auth } from '@/firebase/init'

export async function getCurrentUserBearer(): Promise<string> {
  const user = auth.currentUser
  if (!user) return ''
  return await user.getIdToken()
}

